import React, { useState } from 'react';
import './dashboard-settings-form.sass';
import { useFormik } from 'formik';
import { unwrapResult } from '@reduxjs/toolkit';
import { patchEmail, patchPassword } from '../dashboard-settings.slice';
import { Input } from '../../../../components/interface/input/input';
import { Button, ButtonSize, ButtonType } from '../../../../components/interface/button/button';
import { useDispatch, useSelector } from 'react-redux';
import { useSessionService } from '../../../../services/session/use-session.service';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { Config } from '../../../../config/config';
import * as Yup from 'yup';

const FormSchema = Yup.object().shape({
   email: Yup.string().email('Email nieprawidłowy').max(105, 'Za długi!'),
   currentpassword: Yup.string().min(6, 'Za krótkie!'),
   newpassword: Yup.string().min(6, 'Za krótkie!').max(25, 'Za długi!'),
   confirmpassword: Yup.string().oneOf([Yup.ref('newpassword'), null], 'Podane hasła nie zgadzają się!').min(6, 'Za krótkie!')
});

export const DashboardSettingsForm = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const sessionData = useSelector(state => state.session.data);
  const { logout } = useSessionService();
  const [isEditing, setIsEditing] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: sessionData?.email || '',
      newpassword: '',
      confirmpassword: '',
      currentpassword: '',
    },
    validationSchema: FormSchema,
    onSubmit: values => {
        const _promiseArray = [];
        if (values.email !== sessionData?.email) {
            _promiseArray.push(dispatch(patchEmail({payload: {email: values.email}}))
                .then(unwrapResult)
                .then(() => {
                    toast.success('Email zmieniony!');
                }, () => {
                    toast.error('Nie udało się zmienić email, coś poszło nie tak');
                }));
        }
        if (values.currentpassword && values.newpassword && values.confirmpassword) {
            _promiseArray.push(dispatch(patchPassword({payload: values}))
                .then(unwrapResult)
                .then(() => {
                    toast.success('Hasło zmienione!');
                    formik.resetForm();
                }, () => {
                    toast.error('Nie udało się zmienić hasła, coś poszło nie tak');
                }));
        }
        if (_promiseArray.length > 0) {
            Promise.all(_promiseArray).then( () =>{
                logout();
                history.push(Config.routePaths.main.vendor.path);
            }, () => {
                toast.error('Coś poszło nie tak');
            });
        } else {
            toast.success('Nie zmieniono żadnych danych');
        }

    }
  });

  return (
    <div className='vv-dashboard-settings-form'>
      <div className='vv-dashboard-settings-form__title'>
          <h2>Ustawienia</h2>
      </div>
      <form className='vv-dashboard-settings-form__form' onSubmit={formik.handleSubmit}>
          <div className='vv-dashboard-settings-form__margin-bottom'>
              <Input type='text'
                     placeholder='Email'
                     name='email'
                     id='email'
                     label='Email'
                     onChange={formik.handleChange}
                     value={formik.values.email}
                     disabled={!isEditing}
                     textError={formik.touched.email && formik.errors.email}/>
          </div>
          <div className='vv-dashboard-settings-form__margin-bottom'>
              <Input type='password'
                     placeholder='Stare hasło'
                     name='currentpassword'
                     id='currentpassword'
                     label='Stare hasło'
                     onChange={formik.handleChange}
                     value={formik.values.currentpassword}
                     disabled={!isEditing}
                     textError={formik.touched.currentpassword && formik.errors.currentpassword}/>
          </div>
          <div className='vv-dashboard-settings-form__margin-bottom'>
              <Input type='password'
                     placeholder='Hasło'
                     name='newpassword'
                     id='newpassword'
                     label='Hasło'
                     onChange={formik.handleChange}
                     value={formik.values.newpassword}
                     disabled={!isEditing}
                     textError={formik.touched.newpassword && formik.errors.newpassword}/>
          </div>
          <div className='vv-dashboard-settings-form__margin-bottom'>
              <Input type='password'
                     placeholder='Powtórz hasło'
                     name='confirmpassword'
                     id='confirmpassword'
                     label='Powtórz hasło'
                     onChange={formik.handleChange}
                     value={formik.values.confirmpassword}
                     disabled={!isEditing}
                     textError={formik.touched.confirmpassword && formik.errors.confirmpassword}/>
          </div>
        {
            isEditing ?
                <div className='vv-dashboard-settings-form__button-container'>
                    <div className='vv-dashboard-settings-form__margin-right'>
                        <Button type='button' onClick={formik.submitForm} buttonType={ButtonType.BLACK} size={ButtonSize.VENDOR} text='ZAPISZ'/>
                    </div>
                    <Button type='button' onClick={() => setIsEditing(false)} buttonType={ButtonType.TRANSPARENT_BORDER} size={ButtonSize.VENDOR} text='ANULUJ'/>
                </div>
            :
                <div className='vv-dashboard-settings-form__margin-bottom'>
                    <Button type='button' onClick={() => setIsEditing(true)} buttonType={ButtonType.TRANSPARENT_BORDER} size={ButtonSize.VENDOR} text='EDYTUJ'/>
                </div>
        }
      </form>
    </div>
  );
};
